if (!customElements.get('product-sticky-bar')) {
  class ProductStickyBar extends HTMLElement {
    constructor() {
      super();
      this.latestFormCondition = false;
      this.latestFooterCondition = false;
      this.observer = new IntersectionObserver(this.onIntersection.bind(this));
      this.variantChangeUnsubscriber = undefined;
    }

    connectedCallback() {
      this.formElement = document.getElementById(this.getAttribute('form'));
      this.footerElement = document.querySelector('.shopify-section-group-footer-group');
      this.mainSubmitButton = document.getElementById(this.getAttribute('submit-button-id'));
      this.stickySubmitButton = this.querySelector('[data-sticky-submit]');
      this.priceElement = document.getElementById(this.getAttribute('price-id'));
      this.stickyPriceElement = this.querySelector('[data-sticky-price]');
      this.alwaysVisible = this.dataset.alwaysVisible === 'true';
      this.mobileMedia = window.matchMedia('(max-width: 989px)');

      if (this.formElement) {
        this.observer.observe(this.formElement);
      }

      if (this.footerElement) {
        this.observer.observe(this.footerElement);
      }

      this.mobileMedia.addEventListener('change', this.updateVisibility.bind(this));
      this.syncFromMainButton();
      this.setBarHeight();

      if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (event.data.sectionId !== this.getAttribute('section-id')) return;
          this.syncFromMainButton();
          this.syncPrice(event.data.html);
        });
      }

      this.updateVisibility();
      window.addEventListener('resize', this.setBarHeight.bind(this));
    }

    disconnectedCallback() {
      this.observer.disconnect();
      this.variantChangeUnsubscriber?.();
      window.removeEventListener('resize', this.setBarHeight.bind(this));
      this.mobileMedia.removeEventListener('change', this.updateVisibility.bind(this));
      document.body.classList.remove('product-has-sticky-atc');
      document.documentElement.style.removeProperty('--sticky-atc-height');
    }

    onIntersection(entries) {
      entries.forEach((entry) => {
        if (entry.target === this.formElement) {
          this.latestFormCondition = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
        }

        if (entry.target === this.footerElement) {
          this.latestFooterCondition = !entry.isIntersecting;
        }
      });

      this.updateVisibility();
    }

    updateVisibility() {
      const isMobile = this.mobileMedia.matches;
      const showOnDesktop = this.latestFooterCondition && this.latestFormCondition;
      const showOnMobile = this.alwaysVisible
        ? this.latestFooterCondition
        : showOnDesktop;

      this.classList.toggle('is-visible', isMobile ? showOnMobile : showOnDesktop);
      document.body.classList.toggle('product-has-sticky-atc', isMobile && showOnMobile);
      this.setBarHeight();
    }

    setBarHeight() {
      if (!this.mobileMedia.matches || !this.classList.contains('is-visible')) {
        document.documentElement.style.removeProperty('--sticky-atc-height');
        return;
      }

      document.documentElement.style.setProperty('--sticky-atc-height', `${this.offsetHeight}px`);
    }

    syncFromMainButton() {
      if (!this.mainSubmitButton || !this.stickySubmitButton) return;

      const label = this.mainSubmitButton.querySelector('span');
      const stickyLabel = this.stickySubmitButton.querySelector('span');

      if (label && stickyLabel) {
        stickyLabel.textContent = label.textContent;
      }

      this.stickySubmitButton.disabled = this.mainSubmitButton.disabled;
      this.stickySubmitButton.setAttribute('aria-disabled', this.mainSubmitButton.getAttribute('aria-disabled') || 'false');
    }

    syncPrice(html) {
      if (!this.priceElement || !this.stickyPriceElement) return;

      const sectionId = this.getAttribute('section-id');
      const updatedPrice = html?.getElementById(`price-${sectionId}`);

      if (updatedPrice) {
        this.stickyPriceElement.innerHTML = updatedPrice.innerHTML;
      } else {
        this.stickyPriceElement.innerHTML = this.priceElement.innerHTML;
      }
    }
  }

  customElements.define('product-sticky-bar', ProductStickyBar);
}
